import { render } from "./AdminBar.vue?vue&type=template&id=e8d9f1f6"
import script from "./AdminBar.vue?vue&type=script&lang=js"
export * from "./AdminBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/AdminBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e8d9f1f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e8d9f1f6', __exports__)) {
    api.reload('e8d9f1f6', __exports__)
  }
  
  module.hot.accept("./AdminBar.vue?vue&type=template&id=e8d9f1f6", () => {
    api.rerender('e8d9f1f6', render)
  })

}


export default __exports__